// extracted by mini-css-extract-plugin
export var errorIcon = "_np-1";
export var nameLogo = "_np-0";